import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader")!

  return (_openBlock(), _createBlock(_component_v_skeleton_loader, _mergeProps({ class: _ctx.classes }, _ctx.$attrs), null, 16, ["class"]))
}